<div class="row content" *appRole="['Propiedades.Ver']">
    <div class="col-sm-2">
        <app-nav-panel-propiedad [idPropiedad]="idPropiedad"></app-nav-panel-propiedad>
    </div>

    <!-- Esta pantalla es SÓLO edición de los datos de la propiedad.
         Propietarios, Características y Auditoría viven en la vista de consulta
         (ver-propiedad): mezclar la carga de datos con la gestión de propietarios
         en la misma pantalla hacía que se entrara a editar para mirar. -->
    <div class="col-sm-10 position-relative">
        <ngx-spinner [zIndex]=100 name="spPropiedad" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
            type="ball-atom" [fullScreen]="false"></ngx-spinner>

        <div class="acciones-propiedad">
            <button mat-stroked-button color="primary" *appRole="['Propiedades.Ver']" (click)="verPropiedad()">
                <mat-icon>visibility</mat-icon>
                Ver ficha
            </button>
        </div>

        <form [formGroup]="propiedadForm" *ngIf="propiedadDto" class="container-mat-card">

            <div class="row">
                <div class="col-6">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Ubicación</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>

                            <div class="row">
                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Ubicacion</mat-label>
                                        <input matInput name="Ubicacion" style="text-transform: uppercase;" type="text" maxlength="200" formControlName="Ubicacion" />
                                        <mat-error *ngIf="f.Ubicacion.errors?.maxlength">Supero el maximo de caracteres.</mat-error>
                                        <mat-error *ngIf="f.Ubicacion.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Codigo CPA</mat-label>
                                        <input matInput name="CodigoCpa" type="text" maxlength="8" formControlName="CodigoCpa" />
                                        <mat-error *ngIf="f.CodigoCpa.errors?.maxlength">Supero el maximo de caracteres.</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Piso</mat-label>
                                        <input matInput name="Piso" style="text-transform: uppercase;" maxlength="5" type="text" formControlName="Piso" />
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Departamento</mat-label>
                                        <input matInput name="Departamento" style="text-transform: uppercase;" maxlength="5" type="text" formControlName="Departamento" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-12">
                                    <app-buscar-localidad [localidadBasicDto]="propiedadDto.localidad"
                                        (eventoLocalidad)="seleccionaLocalidad($event)"></app-buscar-localidad>
                                </div>
                            </div>

                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="col-6">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Clasificación</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>

                            <div class="row">
                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Tipo Propiedad</mat-label>
                                        <mat-select formControlName="TiposPropiedad" (selectionChange)="selectTiposPropiedad($event)">
                                            <mat-option [value]="tipoPropiedad.id" *ngFor="let tipoPropiedad of lstTiposPropiedad ;let i=index;trackBy:trackByItems">
                                                {{tipoPropiedad.descripcion}}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="f.TiposPropiedad.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
                                        <mat-hint>Habilita subtipo de propiedad.</mat-hint>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <ngx-spinner name="spSubTipoPropiedad" bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                                        <mat-label>Subtipo Propiedad</mat-label>
                                        <mat-select formControlName="SubtiposPropiedad">
                                            <mat-option [value]="subtipoPropiedad.id" *ngFor="let subtipoPropiedad of lstSubtiposPropiedad ;let i=index;trackBy:trackByItems">
                                                {{subtipoPropiedad.descripcion}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Clase Propiedad</mat-label>
                                        <mat-select formControlName="ClasePropiedad">
                                            <mat-option [value]="propiedadClase.id" *ngFor="let propiedadClase of lstPropiedadClases ;let i=index;trackBy:trackByItems">
                                                {{propiedadClase.descripcion}}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="f.ClasePropiedad.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
                                    </mat-form-field>
                                </div>

                                <!-- El estado lo maneja el sistema (Con contrato, Disponible, ...).
                                     Se muestra como texto y no como select deshabilitado: un
                                     control disabled queda fuera de form.value y de form.valid. -->
                                <div class="form-group col-6">
                                    <mat-label><b>Estado: </b></mat-label>
                                    <span>{{ propiedadDto.estadoPropiedad?.descripcion }}</span>
                                    <mat-hint class="hint-estado">Lo actualiza el sistema segun los contratos.</mat-hint>
                                </div>
                            </div>

                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Medidas y valor</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>

                            <div class="row">
                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Superficie Total</mat-label>
                                        <span matPrefix>m² &nbsp;</span>
                                        <input matInput name="SuperficieTotal" min="0" type="number" formControlName="SuperficieTotal" />
                                        <mat-error *ngIf="f.SuperficieTotal.errors?.min">No puede ser negativa.</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Superficie Cubierta</mat-label>
                                        <span matPrefix>m² &nbsp;</span>
                                        <input matInput name="SuperficieCubierta" min="0" type="number" formControlName="SuperficieCubierta" />
                                        <mat-error *ngIf="f.SuperficieCubierta.errors?.min">No puede ser negativa.</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Precio</mat-label>
                                        <span matPrefix>U$S &nbsp;</span>
                                        <input matInput name="Precio" min="0" mask="separator.2" thousandSeparator="," type="text" formControlName="Precio" />
                                        <mat-error *ngIf="f.Precio.errors?.min">No puede ser negativo.</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Antiguedad</mat-label>
                                        <input matInput name="Antiguedad" type="text" maxlength="50" formControlName="Antiguedad" />
                                        <mat-error *ngIf="f.Antiguedad.errors?.maxlength">Supero el maximo de caracteres.</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- El error es del formulario, no de un campo: no puede vivir
                                 dentro de un mat-form-field -->
                            <div class="alerta-validacion" *ngIf="propiedadForm.errors?.cubiertaMayorQueTotal">
                                <mat-icon>error_outline</mat-icon>
                                La superficie cubierta no puede ser mayor que la superficie total.
                            </div>

                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="col-6">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Datos registrales</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>

                            <div class="row">
                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Tipo de Folio</mat-label>
                                        <mat-select (selectionChange)="selectTipoFolio($event.value)" formControlName="TipoFolio">
                                            <mat-option [value]="tipoFolio.id" *ngFor="let tipoFolio of lstTiposFolios;let i=index;trackBy:trackByItems ">
                                                {{tipoFolio.descripcion}}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="f.TipoFolio.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-6" *ngIf="idTipoFolio===1 || idTipoFolio===2">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Nro. Folio</mat-label>
                                        <input matInput name="NroFolio" type="text" maxlength="50" formControlName="NroFolio" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row" *ngIf="idTipoFolio===1">
                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Tomo</mat-label>
                                        <input matInput name="Tomo" type="text" maxlength="50" formControlName="Tomo" />
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-6">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Numero</mat-label>
                                        <input matInput name="Numero" type="text" maxlength="50" formControlName="Numero" />
                                        <mat-error *ngIf="f.Numero.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-6">
                                    <mat-checkbox formControlName="Horizontal">
                                        Es propiedad Horizontal?
                                    </mat-checkbox>
                                </div>
                                <div class="form-group col-6">
                                    <mat-checkbox formControlName="NotificarRecibo"
                                        matTooltip="Al emitir un recibo de esta propiedad se envía una copia oculta a los correos configurados en Parámetros del Sistema.">
                                        Avisar por mail al emitir recibo
                                    </mat-checkbox>
                                </div>
                            </div>

                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Observaciones</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>

                            <div class="row">
                                <div class="form-group col-12">
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Observaciones</mat-label>
                                        <textarea matInput #message name="Observacion" formControlName="Observacion"></textarea>
                                        <mat-error *ngIf="f.Observacion.errors?.maxlength">Supero el maximo de caracteres.</mat-error>
                                        <mat-hint align="start"><strong>Amplie información personal</strong> </mat-hint>
                                        <mat-hint align="end">{{message.value.length}} / 2000</mat-hint>
                                    </mat-form-field>
                                </div>
                            </div>

                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

            <!-- ---------- ACCIONES ---------- -->
            <div class="acciones">
                <!-- El botón queda siempre habilitado: al apretarlo se marcan los
                     campos que faltan en vez de dejar al usuario adivinando -->
                <button mat-raised-button *appRole="['Propiedades.Modificar']" color="primary"
                    name="Guardar" (click)="onSubmit()">Guardar</button>

                <button mat-button color="warn" name="Cancelar" (click)="goBack()">Cancelar</button>

                <span class="aviso-cambios" *ngIf="propiedadForm.dirty">Cambios sin guardar</span>
            </div>

            <div class="alerta-validacion" *ngIf="mensajeValidacion">
                <mat-icon>error_outline</mat-icon>
                {{ mensajeValidacion }}
            </div>

        </form>
    </div>
</div>
